var map = {
	"./de-de/countries.json": [
		672,
		7
	],
	"./es-es/countries.json": [
		673,
		6
	],
	"./fr-ca/countries.json": [
		674,
		5
	],
	"./fr-fr/countries.json": [
		675,
		4
	],
	"./it-it/countries.json": [
		676,
		3
	],
	"./nb-no/countries.json": [
		677,
		2
	],
	"./nl-nl/countries.json": [
		678,
		1
	],
	"./sv-se/countries.json": [
		679,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1621;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./locale lazy ^\.\/.*\/countries\.json$
// module id = 1621
// module chunks = 69